import { Trigger } from "@radix-ui/react-alert-dialog";

type AlertTriggerProps = {
  asChild: boolean;
  children?: React.ReactNode;
};

const AlertTrigger = ({ children, asChild = false }: AlertTriggerProps) => (
  <Trigger asChild={asChild}>{children}</Trigger>
);

export { AlertTrigger };
